<template>
  <!-- <Skeleton :loading="loading"> -->
  <div class='Normed'>
      <div class="normed-header">
      <Header>
        <div v-if="message.checkFlag != 1">
          <span @click="onClickRight" class="delete">修改</span>
        </div>
      </Header>
      <div>
        <!-- 国家税务局通用定额发票 -->
        <div v-if="message.invoiceType === '199' " span="20"  class="sellerName">{{'通用机打发票'}}</div>
        <div v-if="message.invoiceType === '200' " span="20"  class="sellerName">{{'国家税务局通用定额发票'}}</div>
      </div>
      <div class="back-color">
        <div></div>
      </div>
      </div>
        <div class="content">
          <div class="img">
            <div @click="handleShowImg">
              <img :src="getOcrUrl(message.imagePath)" alt="">
            </div>
            <div>
              <div class="huisuiyunfont"><span>{{'\ue630'}}</span>拍照识别</div>
              <div class="huisuiyunfont"><span>{{'\ue632'}}</span>{{message.drewDate}}</div>
              <div class='huisuiyunfont check'>
                <!-- v-if='message.exceptionInfo !="0" && message.exceptionInfo !=null' -->
                <div v-if="message.checkFlag == 0" class="no-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">暂未查验</div>
              </div>
              <div v-if="message.checkFlag == 1">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验成功</div>
              </div>
              <div v-if="message.checkFlag == 2" class="fail-check">
                <div class="icon">{{'\ue631'}}</div>
                <div class="check-text">查验失败</div>
              </div>
                <div  v-if="message.reimbursementFlag !== 0" :class="[getColor(message.reimbursementFlag)]">
                  <div v-if="message.reimbursementFlag === 1" class="icon">{{'\ue66e'}}</div>
                  <div v-if="message.reimbursementFlag === 2" class="icon">{{'\ue66d'}}</div>
                  <div v-if="message.reimbursementFlag === 3" class="icon">{{'\ue66c'}}</div>
                  <div class="check-text" v-if="message.reimbursementFlag === 1">待审批</div>
                  <div class="check-text" v-if="message.reimbursementFlag === 2">已完成</div>
                  <div class="check-text" v-if="message.reimbursementFlag === 3">已驳回</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class='CardType'>
          <CardType :item='message' :time="getTime(this.time)"></CardType>
        </div> -->
        <div class='money'>
          <div class='heard'>金额</div>
          <div class='number'>
            <div class='left iconfont'><span class="money-icon">{{'\ue60a'}}</span><span class="money-font">{{message.amountWithTax}}</span></div>
            <div class='right'>{{message.amountWithTaxBig ? message.amountWithTaxBig : ''}}</div>
          </div>
        </div>
        <div class='must-invoice-three'>
          <MustInvoiceThree :item="message"></MustInvoiceThree>
        </div>
      </div>
      <div class='lookElectornic'>
        <LookElectornic :imgShow.sync="imgShow" :urlImg="message.imagePath"></LookElectornic>
      </div>
  </div>
<!-- </Skeleton> -->
</template>
<script>
import { Icon, Dialog, Notify } from 'vant'
// import CardType from '@/components/CardType'
import { personalInvoicesRequest, officialAccountRequest } from '@services'
import MustInvoiceThree from '@/components/MustInvoiceThree'
import LookElectornic from '@/components/LookElectronic'
import Header from '@/components/Header/index.vue'
export default {
  data () {
    return {
      activeNames: [''],
      id: '',
      exceptionInfo: '',
      message: {},
      time: '',
      imgShow: false,
      loading: true
    }
  },
  async mounted () {
    this.id = this.$route.query.id
    this.time = this.$route.query.time
    const invoiceNo = this.$route.query.no
    const data = await personalInvoicesRequest.personalInvoices.getNonInvoiceInfo({ invoiceNo })
    if (data.success) {
      this.message = data.result
      this.loading = false
    } else {
      Notify({ type: 'danger', message: data.message })
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    handleShowImg () {
      this.imgShow = true
    },
    async onClickRight () {
      this.$store.commit('invoice/changeInfoInvoice', this.message)
      this.$router.push('/newInvoice/editInvoice')
    },
    async onClickCheck () {
      const res = await officialAccountRequest.weChat.saveCollections([this.message])
      if (res.success) {
        Notify.success('操作成功!')
      } else {
        Notify.error(res.message)
      }
    }
  },
  computed: {
    getTime () {
      return function (time) {
        let d = new Date(Number(time))
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}  ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
      }
    },
    getOcrUrl () {
      return (url) => {
        if (url) {
          let index = url.indexOf('http')
          let newUrl = url
          console.log(index)
          if (index === -1) {
            newUrl = 'http://huisuiyun.oss-cn-shanghai.aliyuncs.com/' + url
          }
          return newUrl
        }
      }
    },
    getColor () {
      return (i) => {
        switch (i) {
          case 0:
            return ''
          case 1:
            return 'padding'
          case 2:
            return ''
          case 3:
            return 'back'
          default:
            break
        }
      }
    }
  },
  components: {
    // CardType,
    MustInvoiceThree,
    LookElectornic,
    Header,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Notify.name]: Notify
  }
}
</script>
<style lang='less' scoped>
.Normed {
  font-family: Alibaba PuHuiTi;
  position: relative;
  .normed-header{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: rgba(51, 120, 255, 1);
    .sellerName{
      padding: 0px 0px 120px;
      padding-left: 16px;
      box-sizing: border-box;
      font-size: 48px;
      font-weight: 400;
      color: #FFFFFF;
    }
    .back-color{
      div{
        border-radius: 16px 16px 0 0;
        height: 100px;
        background: rgba(245, 245, 245, 1);
      }
    }
  }
  .content{
    position: absolute;
    widows: 718px;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    .img{
      padding: 24px;
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      border-radius: 8px;
      display: flex;
      margin-bottom: 16px;
      // height: 224px;
    }
    .img>div:first-of-type{
      width: 284px;
      height: 176px;
      overflow: hidden;
      border-radius: 8px;
      img{
        width: 100%;
        border-radius: 8px;
        height: 100%;
      }
    }
    .img>div:last-of-type{
      font-size: 26px;
      color: rgba(122, 134, 153, 0.8);
      flex-grow: 1;
      div{
        margin-bottom: 16px;
      }
      span{
        padding: 0 16px;
      }
    }
  }
  background-color: #f5f5f5;
  // padding: 0px 24px;
  height: 100%;
  /deep/.van-nav-bar {
    background-color: #f5f5f5;
    height: 100px;
    .van-nav-bar__text {
      color: #3e4966;
      font-size: 28px;
    }
    .GoBack {
      color: #3e4966;
    }
  }
  .CardType {
    margin-bottom: 16px;
  }
  .money{
    width: 702px;
    // height: 128px;
    background: #fff;
    padding: 28px 24px 0px;
    margin-bottom: 16px;
    box-sizing: border-box;
    border-radius: 8px;
    .money-icon{
      font-size: 24px;
      display: inline-block;
      vertical-align: top;
    }
    .money-font{
      font-family: "Bahnschrift","PingFang SC";
      font-size: 48px !important;
    }
    .left{
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40px;
      font-family: "Bahnschrift","PingFang SC";
    }
    .number{
      font-size: 40px;
      font-weight: 600;
      color: #3e4966;
      font-family: "Bahnschrift","PingFang SC";
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      div:nth-of-type(2){
        font-size: 24px;
        font-family: 'Segoe UI';
        color: #9EA9B9;
      }
    }
    .heard{
      color: #9EA9B9;
      font-size: 24px;
      font-family: 'Segoe UI';
      margin-bottom: 12px;
    }
  }
}
.check{
  box-sizing: border-box;
  padding: 16px 0 0 16px;
  display: flex;
  .check-text{
    font-weight: bold;
  }
  .icon{
    margin: 2px 4px 0px;
  }
}
.check>div:first-of-type {
  padding: 2px 12px;
  background: rgba(14, 169, 117, 0.12);
  color: rgba(14, 169, 117, 1);
  display: flex;
  align-items: center;
  text-align: center;
  height: 40px;
  margin-right: 8px;
  div{
    margin-bottom: 0 !important;
  }
}
.check>div:last-of-type {
  display: flex;
  align-items: center;
  padding: 2px 12px;
  background: rgba(14, 169, 117, 0.12);
  color: rgba(14, 169, 117, 1);
  text-align: center;
  div{
    margin-bottom: 0 !important;
  }
}
.padding {
  color: rgba(255, 167, 77, 1) !important;
  background: rgba(255, 167, 77, 0.12) !important;
}
.back {
  color: rgba(255, 111, 92, 1) !important;
  background: rgba(255, 111, 92, 0.12) !important;
}
  .fail-check{
    background-color: rgba(241, 89, 69, 0.12) !important;
    color: #f15945 !important;
  }
  .no-check{
    background: rgba(255, 153, 51, 0.1) !important;
    color: #ff9933 !important;
  }
</style>
